import Navbar from './NavBar';

const NavBarSite = () => <Navbar homeOnly />;

export default NavBarSite;
